import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function SmsConsent() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [form, setForm] = useState({ name: "", phone: "", agree: false });
  const [done, setDone] = useState(false);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/sms-consent/${slug}`).then(r => setC(r.data)).catch(() => setC({ company: "This company" }));
  }, [slug]);
  if (!c) return null;
  return (
    <div className="min-h-screen bg-slate-50 flex items-start justify-center p-6" data-testid="sms-consent-page">
      <div className="w-full max-w-lg bg-white border-2 border-slate-900 shadow-[6px_6px_0_#0f172a] p-6 space-y-4">
        <h1 className="text-2xl font-black uppercase tracking-tight">{c.company} — Text Message Consent</h1>
        <p className="text-sm text-slate-700">By providing your mobile number you agree to receive <b>maintenance-related text messages</b> from {c.company}: work-order updates, technician ETAs, appointment confirmations, and emergency dispatch notices.</p>
        <ul className="text-xs text-slate-600 list-disc pl-5 space-y-1">
          <li>Message frequency varies by activity on your account.</li>
          <li>Message and data rates may apply.</li>
          <li>Reply <b>STOP</b> at any time to opt out. Reply <b>HELP</b> for help{c.phone ? ` or call ${c.phone}` : ""}.</li>
          <li>Your number is never sold or shared with third parties for marketing.</li>
        </ul>
        {done ? (
          <div className="border-2 border-emerald-500 bg-emerald-50 p-3 text-sm font-bold text-emerald-900" data-testid="consent-done">Thanks — you're opted in. Reply STOP to any message to opt out.</div>
        ) : (
          <form className="space-y-3" onSubmit={e => { e.preventDefault(); if (form.agree) setDone(true); }}>
            <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" className="w-full h-10 px-3 border border-slate-300 text-sm" data-testid="consent-name"/>
            <input required value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Mobile number" className="w-full h-10 px-3 border border-slate-300 text-sm" data-testid="consent-phone"/>
            <label className="flex items-start gap-2 text-xs text-slate-700">
              <input type="checkbox" checked={form.agree} onChange={e => setForm({ ...form, agree: e.target.checked })} className="mt-0.5 w-4 h-4" data-testid="consent-agree"/>
              I agree to receive text messages from {c.company} at the number provided. Consent is not a condition of tenancy or service.
            </label>
            <button type="submit" disabled={!form.agree} className="h-10 px-5 bg-slate-900 text-white font-black uppercase text-xs tracking-widest disabled:opacity-40" data-testid="consent-submit">I agree — opt me in</button>
          </form>
        )}
        <div className="text-[10px] text-slate-400">{c.website && <a href={c.website} className="underline">{c.website}</a>} · Powered by Field Radar</div>
      </div>
    </div>
  );
}
